<template>
  <div
    class="input-secret"
    v-bind:class="tags">
    <label>
      <span class="input-secret__label">{{ label }}</span>
      <input
        class="input-secret__input"
        data-lpignore="true"
        required
        v-bind="maxLength ? { maxlength: maxLength } : {}"
        v-bind:class="inputClasses"
        v-bind:type="type"
        v-bind:value="value"
        v-on:input="onInput" />
    </label>
    <label
      class="input-secret__eye"
      title="Показать пароль"
      v-bind:class="{ open: eyeOpen }">
      Показать пароль
      <input
        type="checkbox"
        v-model="eyeOpen" />
    </label>
    <p
      class="input-secret__violation"
      role="alert"
      v-for="text in violations"
      v-bind:key="text"
    >{{ text }}</p>
  </div>
</template>
<script>
export default {
  computed: {
    tags() {
      const list = [];
      if (this.violations.length > 0) {
        list.push('invalid');
      }
      return list;
    },
    type() {
      return this.eyeOpen ? 'text' : 'password';
    },
  },
  data() {
    return {
      eyeOpen: false,
    };
  },
  methods: {
    /**
     * @description Обработать ввод значения.
     * @param {InputEvent} event
     * @returns {void}
     */
    onInput(event) {
      const { value } = event.target;
      this.$emit('input', value);
    },
  },
  name: 'InputSecret',
  props: {
    /**
     * @description Классы элемента ввода.
     * @type {Object.<string,boolean>}
     */
    inputClasses: {
      default: () => ({}),
      required: false,
      type: Object,
    },
    /**
     * @description Заголовок.
     * @type {string}
     */
    label: {
      required: true,
      type: String,
    },
    /**
     * @description Максимально ожидаемое количество символов.
     * @type {number}
    */
    maxLength: {
      default: () => 0,
      required: false,
      type: Number,
    },
    /**
     * @description Значение.
     * @type {string}
     */
    value: {
      default: () => '',
      required: false,
      type: String,
    },
    /**
     * @description Список нарушений.
     * @type {string[]}
     */
    violations: {
      default: () => [],
      required: false,
      type: Array,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
@use "@/scss/fields";
.input-secret {
  display: flex;
  position: relative;
  flex-direction: column;
  &__eye {
    background: url("@/assets/img/eye-closed.svg") no-repeat center;
    cursor: pointer;
    font-size: 0;
    min-height: 2rem;
    min-width: 2rem;
    position: absolute;
    right: .5rem;
    top: 2.5rem;
  }
  &__eye.open {
    background-image: url("@/assets/img/eye-open.svg");
  }
  &__eye > input {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  &__label {
    color: var(--unfocus-color);
    font-size: .75rem;
    font-weight: 400;
    line-height: 1rem;
    margin: 0 0 2px 0;
  }
  &__input {
    @include fields.input-field();
  }
  &.invalid &__input {
    color: var(--warning-color);
  }
  &__violation {
    color: var(--warning-color);
    font-size: .75rem;
    line-height: 14px;
    font-weight: 400;
    padding: .125rem;
  }
}
</style>
